(function () {
  // Bandes de nuances sur les paliers de couleurs et cartouche d'atelier de la fiche produit.
  // Le nombre de cases d'une bande est le nombre reel de couleurs du palier (24, 36, 48), lu dans
  // le libelle de l'option. Les teintes sont une rampe de valeurs de la palette du site, pas les
  // pots du kit : la bande dit "combien", jamais "lesquelles".
  var m = location.pathname.match(/\/products\/([^\/?#]+)/);
  if (!m) return;
  var handle = m[1];
  var produit = null;

  function nombreCouleurs(txt) {
    var r = /(^|\D)(24|36|48)(\D|$)/.exec(txt || "");
    return r ? +r[2] : 0;
  }
  function bande(n) {
    var s = document.createElement("span");
    s.className = "abn-bande";
    s.setAttribute("data-n", n);
    s.setAttribute("aria-hidden", "true");
    for (var i = 0; i < n; i++) {
      var c = document.createElement("i");
      var t = n === 1 ? 0 : i / (n - 1);
      // rampe de valeur : encre -> bordeaux -> rose -> papier, un seul axe de clarte
      var l = 14 + Math.round(t * 78);
      var sat = 44 - Math.round(t * 20);
      c.style.background = "hsl(338 " + sat + "% " + l + "%)";
      s.appendChild(c);
    }
    return s;
  }
  function poserBandes() {
    var cibles = [];
    var vr = document.querySelector("variant-radios");
    if (vr) {
      Array.prototype.forEach.call(vr.querySelectorAll("input[type=radio]"), function (inp) {
        var lab = vr.querySelector('label[for="' + inp.id + '"]');
        var n = nombreCouleurs(inp.value);
        if (lab && n && /colou?rs|couleurs|farben|colores|colori|kleuren/i.test(inp.name + " " + inp.value)) cibles.push([lab, n]);
      });
    }
    Array.prototype.forEach.call(document.querySelectorAll(".abn-paliers li > strong:first-child"), function (st) {
      var n = nombreCouleurs(st.textContent);
      if (n) cibles.push([st.parentNode, n, st]);
    });
    cibles.forEach(function (c) {
      var hote = c[0];
      if (hote.querySelector(":scope > .abn-bande")) return;
      var b = bande(c[1]);
      if (c[2]) hote.insertBefore(b, c[2].nextSibling); else hote.insertBefore(b, hote.firstChild);
      hote.classList.add("abn-a-bande");
    });
  }

  function cartouche() { return document.querySelector(".abn-cartouche"); }
  function idCourant() {
    var b = document.querySelector('select[name="vopo-id"]');
    if (b && b.value) return +b.value;
    var f = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    return f ? +f.value : 0;
  }
  var dernierId = 0;
  function remplirCartouche() {
    var c = cartouche();
    if (!c || !produit) return;
    var id = idCourant();
    if (!id || id === dernierId) return;
    var v = null;
    for (var i = 0; i < produit.variants.length; i++) if (produit.variants[i].id === id) v = produit.variants[i];
    if (!v) return;
    dernierId = id;
    Array.prototype.forEach.call(c.querySelectorAll("[data-opt]"), function (dd) {
      var k = +dd.getAttribute("data-opt");
      var val = v.options[k - 1];
      if (val == null) return;
      var nom = (produit.options[k - 1] || "").toLowerCase();
      if (/frame|cadre/.test(nom)) {
        dd.textContent = /^no\b|canvas only|sans/i.test(val) ? dd.getAttribute("data-non") : dd.getAttribute("data-oui");
      } else if (/color|couleur/.test(nom)) {
        var n = nombreCouleurs(val);
        dd.textContent = n ? n + " " + dd.getAttribute("data-unite") : val;
        var b = c.querySelector(".abn-cartouche__bande");
        if (b && n) { b.innerHTML = ""; b.appendChild(bande(n)); }
      } else {
        dd.textContent = val.replace(/\s*-\s*(Recommended|Jumbo Square|Small Square|Recommandé|Carré.*|Grand.*)$/i, "");
      }
    });
    var sku = c.querySelector("[data-sku]");
    if (sku) sku.textContent = v.sku || "";
  }

  var attente = null;
/* lot 5 (2026-10-12) : chevalet a la taille choisie, gain affiche sur l'etiquette d'offre */
  var L5 = {
    en: { shown: "Preview shown at", gain: "Two of this kit: you keep" },
    fr: { shown: "Aperçu à la taille", gain: "Deux fois ce kit : vous gardez" },
    de: { shown: "Vorschau in der Größe", gain: "Zweimal dieses Set: Sie sparen" },
    es: { shown: "Vista previa al tamaño", gain: "Dos de este kit: te ahorras" },
    it: { shown: "Anteprima alla misura", gain: "Due di questo kit: risparmi" }
  };
  function l5t(k) { var l = (document.documentElement.lang || "en").slice(0, 2); return (L5[l] || L5.en)[k]; }
  function l5v() {
    if (!produit) return null;
    var id = idCourant();
    for (var i = 0; i < produit.variants.length; i++) if (produit.variants[i].id === id) return produit.variants[i];
    return null;
  }
  function l5taille(s) {
    var m = /(\d+(?:\.\d+)?)\s*"?\s*x\s*(\d+(?:\.\d+)?)/i.exec(s || "");
    if (!m) return null;
    var w = +m[1], h = +m[2];
    return { px: Math.round(Math.max(220, Math.min(340, 220 + (w - 12) * 10.5))), etiq: w + "\u2033\u00d7" + h + "\u2033" };
  }
  var l5dernier = "";
  function chevalet() {
    var a = document.getElementById("abn-photo-apercu"), toile = document.getElementById("abn-ap-toile");
    if (!a || !toile || !produit) return;
    var v = l5v(); if (!v) return;
    var k = -1;
    for (var i = 0; i < produit.options.length; i++) if (/size|taille/i.test(produit.options[i])) k = i;
    if (k < 0) return;
    var t = l5taille(v.options[k]); if (!t) return;
    if (t.etiq === l5dernier && a.querySelector(".abn-ap-taille")) return;
    l5dernier = t.etiq;
    toile.style.maxWidth = t.px + "px";
    var c = a.querySelector(".abn-ap-taille");
    if (!c) { c = document.createElement("span"); c.className = "abn-ap-taille"; toile.insertAdjacentElement("afterend", c); }
    c.textContent = "";
    c.appendChild(document.createTextNode(l5t("shown") + " "));
    var b = document.createElement("b"); b.textContent = t.etiq; c.appendChild(b);
  }
  function l5money(cents, fmt) {
    var f = fmt || "${{amount}}", n = cents / 100;
    function sep(x, dec, th) { var p = n.toFixed(dec).split("."); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th); return p.join(x); }
    var s = f.replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, sep(",", 0, "."))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, sep(",", 2, "."))
      .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/, sep(".", 2, "'"))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, sep(".", 0, ","))
      .replace(/\{\{\s*amount\s*\}\}/, sep(".", 2, ","));
    return s.replace(/<[^>]+>/g, "");
  }
  var l5gainDernier = 0;
  function gainOffre() {
    var g = document.querySelector("[data-abn-gain]"); if (!g || !produit) return;
    var v = l5v(); if (!v || v.id === l5gainDernier) return;
    l5gainDernier = v.id;
    var gain = Math.round(v.price * 2 * 0.15);
    g.textContent = "";
    g.appendChild(document.createTextNode(l5t("gain") + " "));
    var b = document.createElement("b"); b.textContent = l5money(gain, g.getAttribute("data-fmt")); g.appendChild(b);
    g.hidden = false;
  }
  function lot5() { try { chevalet(); gainOffre(); } catch (e) {} }
  function planifier() { clearTimeout(attente); attente = setTimeout(function () { poserBandes(); remplirCartouche(); lot5(); }, 60); }

  fetch("/products/" + handle + ".js", { credentials: "same-origin" })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (p) {
      if (p && p.variants) {
        p.options = p.options.map(function (o) { return typeof o === "string" ? o : o.name; });
        produit = p;
      }
      planifier();
      document.addEventListener("change", planifier);
      setInterval(function () { remplirCartouche(); lot5(); }, 700);
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var t = muts[i].target;
          if (t.closest && (t.closest("variant-radios") || t.closest(".abn-paliers")) && !(t.classList && (t.classList.contains("abn-bande") || t.classList.contains("abn-a-bande")))) { planifier(); return; }
        }
      }).observe(document.body, { childList: true, subtree: true });
    })
    .catch(function () { planifier(); });
})();
